export default "__VITE_ASSET__GdoCY$6i__"